import {Inject, Injectable, Injector, Renderer2, RendererFactory2} from '@angular/core';
import {TranslocoService} from '@jsverse/transloco';
import {GlobalService} from 'app/global/global.service';
import feather from 'feather-icons';
import uuid from 'short-unique-id';
import {PopOver} from '../popover/popover';
import { Editor } from '@tiptap/core';
import { ElementPosition } from '../content-tab/content-tab.dto';
import { SessionImageService } from 'app/global/session-image.service';

@Injectable({
    providedIn: 'root',
})
export class contentFields {
    public instance_name = '';
    public uuid = new uuid({ length: 6, dictionary: 'number' });
    public keydownCount = 0;
    public selectMenuIsOpen = false;
    private renderer: Renderer2;
    constructor(@Inject(Injector) private readonly injector: Injector, private _translocoService:TranslocoService, rendererFactory: RendererFactory2, private sessionImageService: SessionImageService) {
        this.renderer = rendererFactory.createRenderer(null, null);
    }

    /**
     * return the field block html for editor
     * @param params 
     */
    textFieldBlockHtml(params: { uuid?: string} = {}) {
        return `
        <div contenteditable="false" class="form-builder-table drag-fields" uuid="${params.uuid}" field_required="1" column="100">
            <div class="custum-form-builder-box fields-ele-container">
                <label class="custum-form-builder-label selected-label">${this._translocoService.translate("Content new field (Template/Document - section) - Field name - New field")}</label>
                <input class="custum-form-builder-field form-control form-builder-field-label text-field-input" type="text" placeholder="">
                <textarea class="hidden text-field-textarea form-control" placeholder="${this._translocoService.translate("Content new field (Template/Document - section) - Field name - New field")}"></textarea>
            </div>
        </div>
     `;
    }

    /**
     * return the datepicker block html for editor
     * @param params 
     */
    datepickerFieldBlockHtml(params: { uuid?: string} = {}) {
        return `
        <div contenteditable="false" class="form-builder-table drag-fields" uuid="${params.uuid}" field_required="1" column="100" field_fontsize="14">
            <div class="custum-form-builder-box fields-ele-container">
                <label class="custum-form-builder-label selected-label">${this._translocoService.translate("Content new field (Template/Document - section) - Field name - New field")}</label>
                <input class="custum-form-builder-field form-control form-builder-field-label datepicker-field" type="text" placeholder="">
            </div>
        </div>
        `;
    }

    /**
     * return the checkbox block html for editor
     * @param params 
     */
    checkboxFeildBlockHtml(params: { uuid?: string} = {}) {
        return `<div class="form-builder-table checkbox-field drag-fields" uuid="${params.uuid}" field_required="1" field_fontsize="14" column="100">
                <div class="drag-fields-inner-container checkbox-field-inner-container fields-ele-container">
                    <div class="checkbox-field-box">
                        ${feather.icons.check.toSvg({ class: 'cursor-pointer checkbox-checkIcon', width: 14, height: 14 })}
                    </div>
                    <span class="field-label checkbox-field-label selected-label">${this._translocoService.translate("Content new field (Template/Document - section) - Field name - New field")}</span>
                </div>
            </div>
        `;
    }

    /**
     * return the droplist block html for editor
     * @param params 
     */
    droplistFeildBlockHtml(params: { uuid?:string } = {}) {
        const uuid = params.uuid;
        return `<div class="form-builder-table droplist-field drag-fields" uuid="${uuid}" field_required="1" field_fontsize="14" column="50">
                <div class="drag-fields-inner-container droplist-field-inner-container fields-ele-container">
                    <span class="custum-form-builder-label field-label selected-label">${this._translocoService.translate("Content new field (Template/Document - section) - Field name - New field")}</span>
                    <div class="droplist-inner-box droplist-menu">
                        <span class="selected-option-label droplist-option-label form-builder-field-label" droplistplaceholder="${this._translocoService.translate("Content droplist select option (Template/Document - section) - Select option")}"></span>
                        ${feather.icons['chevron-down'].toSvg({ class: 'cursor-pointer droplist-arrowDown', width: 14, height: 14 })}
                        <ng-dropdown-panel role="listbox" aria-label="Options list" class="ng-dropdown-panel ng-select-bottom droplist-dropdown hidden">
                            <div class="ng-dropdown-panel-items scroll-host">
                                <div class="ng-dropdown-header hidden">
                                    <input type="text" class="form-control w-100 search-drop-value" uuid="${uuid}">
                                </div>
                                <div class="ng-dropdown-custom-options"></div>
                            </div>
                        </ng-dropdown-panel>
                    </div>
                    <div id="${uuid}" data-options='${JSON.stringify([])}'></div>
                </div>
                </div>
            </div>
        `;
    }

    /**
     * return the multiple choice block html for editor
     * @param params 
     */
    multiChoiceFeildBlockHtml(params: { uuid?:string, options? } = {}) {
        const uuid = params.uuid;
        let options = '';
        for (const option of params.options) {
            options += `
                        <div class="multiChoice-item" option_uuid="${option.id}">
                            <div class="multiChoice-box">
                                <div class="multiChoice-inner-circle"></div>
                                ${feather.icons.check.toSvg({ class: 'cursor-pointer multiChoice-inner-check', width: 14, height: 14 })}
                            </div>
                            <label class="multiChoice-label-text">${option.name}</label>
                        </div>`;
        }
        return `<div class="form-builder-table multichoice-field multiChoice-radio drag-fields" uuid="${uuid}" field_required="1" field_fontsize="14" column="100">
                    <div class="custum-form-builder-box">
                        <span class="custum-form-builder-label field-label selected-label">${this._translocoService.translate("Content new field (Template/Document - section) - Field name - New field")}</span>
                        <div class="multiChoice-item-container fields-ele-container">
                            ${options}
                        </div>
                    </div>
                </div>
            `;
    }

    /**
     * return the signature block html for editor
     * @param params 
     */
    signatureFeildBlockHtml(params: { uuid?:string } = {}) {
        return `<div class="form-builder-table signature-field drag-fields" uuid="${params.uuid}" field_required="1" column="100">
                    <div class="drag-fields-inner-container signature-field-inner-container fields-ele-container">
                        <span class="field-label selected-label cursor-pointer pe-auto hidden">${this._translocoService.translate("Content block html text on signature box (Template/Document - section) - Click to add your signature")}</span>
                        <div class="signature-image" style="background-image:url();"></div>
                        <span class="assignee"></span>
                    </div>
                </div>
            `;
    }

    /**
     * return the field block html for editor
     * @param params 
     */
    fieldBlock(params: { type?:string, uuid?:string, options?  } = {}) {
        const uuid = params.uuid;
        const fieldView = this.viewRoute(params.type, uuid, params.options);
        const textBlockElement = document.createElement('div')
        textBlockElement.className = 'content-box content-box-block content-field-block marginminus70';
        textBlockElement.innerHTML = `<div class="sort-helper"></div><div class="content-box-row">
            <div class="rowItem ${params.type}">
                ${this.popOverFunc.listingPopover({ classType: 'field-block', uuid: uuid, contentType: 'settings' })}
                <div class="content-box-inner content-field-inner" editor-uuid="${uuid}" type="${params.type} block">
                    <div class="editor${uuid} cke-editor-placeholder cke-editor-box ${params.type}-block" editor-uuid="${uuid}">
                        <div class="${params.type}-block-parent-container" contenteditable="false">${fieldView}</div>
                    </div>
                </div>
            </div>
        </div>`;
        return textBlockElement;
    }

    /**
     * return the field block zone html for editor
     * @param params 
     */
    fieldBlockZone(params: { uuid?:string, type?:string, options? } = {}) {
        const uuid = params.uuid;
        const fieldView = this.viewRoute(params.type, uuid, params.options);
        const fieldBlockElement = document.createElement('div') as HTMLElement;
        fieldBlockElement.className = `rowItem ${params.type}`;
        fieldBlockElement.innerHTML = ` ${this.popOverFunc.listingPopover({ classType: 'field-block', uuid: uuid, contentType: 'settings' })} <div class="content-box-inner content-field-inner" editor-uuid="${uuid}" type="${params.type} block">
                    <div class="editor${uuid} cke-editor-placeholder cke-editor-box ${params.type}-block" editor-uuid="${uuid}">
                        <div class="${params.type}-block-parent-container" contenteditable="false">${fieldView}</div>
                    </div>
                </div>`;
        return fieldBlockElement;
    }

    /**
     * return the field block html with the position for editor
     * @param params
     * @param callback
     */
    addFieldBlock(params: { uuid?: string, type?:string, position?: string,  options?, editor?:Editor, command?:string } = {}, callback:(uuid)=>void) {
        const uuid = this.uuid();
        const options = { type: params.type, uuid: uuid, options:params.options };
        if (params?.position === ElementPosition.Left) {
            const contentBoxRow = document.querySelector('.content-box-enter')?.querySelector('.content-box-row');
            if (contentBoxRow) {
                this.renderer.insertBefore(contentBoxRow, this.fieldBlockZone(options), contentBoxRow.firstElementChild);
            }
        } else if (params?.position === ElementPosition.Right) {
            const contentBoxRow = document.querySelector('.content-box-enter')?.querySelector('.content-box-row') as Element;
            if (contentBoxRow) {
                this.renderer.appendChild(contentBoxRow, this.fieldBlockZone(options));
            }
        }else{
            const indicator = document.querySelector('.content-box-enter')?.querySelector('[class^="dropIndicator-"]') as HTMLElement;
            if (!document.querySelector('.dropIndicator-bottom') && document.querySelector('.template-page')?.classList.contains('addContentBox') && params?.command !== 'slashcommand') {
                this.renderer.appendChild(document.querySelector('.template-page'), this.fieldBlock(options));
            } else if (params?.editor && params?.command === 'slashcommand') {
                params.editor.view.dom.closest('.content-box').insertAdjacentElement('afterend', this.fieldBlock(options));
            } else if(indicator?.classList?.contains('dropIndicator-inner-bottom')){
                this.globalService.onDropOnInnerIndicator(indicator, this.fieldBlock(options));
            } else {
                const dropIndicatorBottomParent = document.querySelector('.dropIndicator-bottom')?.closest('.content-box');
                if (dropIndicatorBottomParent) {
                    if(params?.position === ElementPosition.Top) {
                        this.renderer.insertBefore(dropIndicatorBottomParent.parentNode, this.fieldBlock(options), dropIndicatorBottomParent);
                    }else{
                        this.renderer.insertBefore(dropIndicatorBottomParent.parentNode, this.fieldBlock(options), dropIndicatorBottomParent.nextSibling);
                    }
                }
            }
        }
        if (callback) {
            callback(uuid);
        }
    }

    /**
     * return the view bsae on viewname
     * @param viewname
     * @param uuid
     * @param options
     */
    viewRoute(viewname: string, uuid: string, options) {
        let view = '';
        switch (viewname) {
            case 'text':
                view = this.textFieldBlockHtml({ uuid: uuid });
                break;
            case 'datepicker':
                view = this.datepickerFieldBlockHtml({ uuid: uuid });
                break;
            case 'checkbox':
                view = this.checkboxFeildBlockHtml({ uuid: uuid });
                break;
            case 'droplist':
                view = this.droplistFeildBlockHtml({ uuid: uuid });
                break;
            case 'multichoice':
                view = this.multiChoiceFeildBlockHtml({ uuid: uuid, options:options });
                break;
            case 'signature':
                view = this.signatureFeildBlockHtml({ uuid: uuid });
                break;
        }
        return view;
    }

    private get popOverFunc() {
        return this.injector.get(PopOver);
    }

    private get globalService() {
        return this.injector.get(GlobalService);
    }
}
